<a mat-list-item [ngStyle]="{'margin-left': (depth * 40) + 'px'}" (click)="onItemSelected()"
   [ngClass]="{'active': menuItem.relativePath ? router.isActive(menuItem.relativePath, true): false, 'expanded': expanded , 'child': depth > 0}"
   class="menu-list-item">

   <!-- <mat-icon *ngIf="menuItem.children && menuItem.children.length"
      class="routeIcon" [@indicatorRotate]="expanded ? 'expanded': 'collapsed'">
    expand_more
  </mat-icon> -->
<!--<mat-icon class="routeIcon">recent_actors</mat-icon>-->
  <!-- {{menuItem.displayName}} -->
  <!--<span fxFlex *ngIf="menuItem.children && menuItem.children.length">
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded': 'collapsed'">
      expand_more
    </mat-icon>
  </span>-->
  <mat-icon  class="menu-icons" *ngIf="depth === 0">
     {{ getIconForDisplayName(menuItem.displayName) }}
   </mat-icon>

   <label class="class-item" [ngClass]="{'child-item': depth > 0}">{{menuItem.displayName}}</label>
   
   <mat-icon *ngIf="menuItem.children && menuItem.children.length"
      class="routeIcon" [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
     expand_more
   </mat-icon>
</a>


<div *ngIf="expanded">
  <tv-menu-item *ngFor="let child of menuItem.children" [menuItem]="child" [sideNav]="sideNav" [depth]="depth + 1">
  </tv-menu-item>
</div>
